export default "__VITE_ASSET__BtRUlS1N__"